import { Col, Input, Modal, Row, Select, Spin, Table, TableColumnsType } from "antd";
import Title from "antd/es/typography/Title";
import { useAppDispatch, useAppSelector } from "app/config/store";
import { setFilterOrgCheckIn, setListFilterOrgCheckIn } from "app/entities/filters/filters.reducer";
import { displayDefaultDateTime } from "app/shared/util/date-utils";
import { filterOption } from "app/shared/util/select-filter";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { checkInStatus } from "../../config";
import OrganizationActiveCheckIn from "./organization-active-check-in";
import { getListOrgCheckIn } from "app/entities/common/common.reducer";

const { Search } = Input;

type ICheckInListProps = {
    isOpen: boolean;
    onClose: () => void;
}

export const CheckInListComponent = ({ isOpen, onClose }: ICheckInListProps) => {
    const dispatch = useAppDispatch();
    const tree = useAppSelector(state => state.common.orgCheckIns);
    const filters = useAppSelector(state => state.filters.orgs);
    const [isLoading, setLoading] = useState(true)
    const [isOpenModelCheckIn, setOpenModelCheckIn] = useState(false)

    useEffect(() => {
        handleGetTreeOrg();
    }, [filters])

    const columns: TableColumnsType<any> = [
        {
            title: 'Tên đơn vị',
            key: 'name',
            render: value => <span className={`${value?.id ? "link-primary cursor-pointer link-underline-opacity-25 link-underline-opacity-100-hover" : ""}`}>{value?.name}</span>
        },
        {
            title: 'Số lượng KR check In',
            key: 'krNumber',
            align: 'center',
            width: 200,
            render: value => value?.id ? value.krNumber : undefined,
        },
        {
            title: 'Thời gian xác nhận hoàn thành check in gần nhất',
            key: 'lastModificationTime',
            width: 300,
            render: value => dayjs.isDayjs(value?.lastModificationTime) && value?.id ? displayDefaultDateTime(value?.lastModificationTime) : undefined
        },
    ];

    const handleFreeTextSearchQuery = query => {
        dispatch(setListFilterOrgCheckIn({ ...filters, searchText: query }))
    };

    const handleChangeCheckInStatus = value => {
        dispatch(setListFilterOrgCheckIn({ ...filters, checkinStatus: value }))
    };

    const handleGetTreeOrg = () => {
        dispatch(getListOrgCheckIn({
            searchText: filters?.searchText,
            accountableId: filters?.accountableId,
            checkinStatus: filters?.checkinStatus,
        })).finally(() => { setLoading(false) })
    }

    const handleClose = () => {
        onClose();
    }

    const handleOpenModelCheckIn = (record) => {
        setOpenModelCheckIn(true)
        dispatch(setFilterOrgCheckIn({ ...filters, accountableId: record.id, accountableName: record.name, }));
    }

    const handleCloseModelCheckIn = () => {
        setOpenModelCheckIn(false)
    }

    return (
        <Modal onCancel={() => { handleClose() }} open={isOpen} maskClosable={false} width={1000} footer={null}>
            <Container className="view">
                <Spin spinning={isLoading} delay={300}>
                    <div className="d-flex gap-5 mt-2">
                        <Row className="d-flex justify-content-between w-100">
                            <Col md={24}>
                                <Row>
                                    <Col md={13}>
                                        <Title level={3}>{`Danh sách check in ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="table">
                        <div className="header">
                            <Col md={18}>
                                <Row className='w-100'>
                                    <Col md={3}>
                                        <Input readOnly size="large" value={tree?.reportScheduleName} />
                                    </Col>
                                    <Col md={1} />
                                    <Col md={6}>
                                        <Select
                                            defaultValue={null}
                                            className="w-100"
                                            onChange={handleChangeCheckInStatus}
                                            options={checkInStatus}
                                            filterOption={filterOption}
                                            size="large"
                                        />
                                    </Col>
                                    <Col md={1} />
                                    <Col md={11}>
                                        <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </div>
                    <Table scroll={{ y: '60vh' }} onRow={(record: any, rowIndex) => {
                        if (record?.id) {
                            return {
                                onClick(event) { { handleOpenModelCheckIn(record); } }, // click row
                            };
                        }
                    }} bordered dataSource={tree?.checkinLists} pagination={false} columns={columns} />
                </Spin>
                {isOpenModelCheckIn && <OrganizationActiveCheckIn isOpen={isOpenModelCheckIn} onClose={handleCloseModelCheckIn} />}
            </Container>
        </Modal>
    );
};
export default CheckInListComponent;